import React, { useState } from 'react';
import { formatCurrency } from '../common/common';
import { useActiveTenantCurrency } from '../common/currencyutils';
import { Grid, Chip } from '@mui/material';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import { getLeadStageTranslationKey } from '../domain/leadstage';
const _ = require('lodash');

export default function ValueSortedCustomerGroup(props) {
    const [toggle, setToggle] = useState(props.openByDefault);
    const { t } = useTranslation();
    // The "all customers" list is scoped to the active tenant only (see
    // PortfolioDataMapper.GetCustomerDescriptiveInfo), so every customer here shares one currency.
    const currency = useActiveTenantCurrency();

    if (props.group.customers.length === 0) return null;

    const onClickItem = (id) => {
        props.history.push(`/customers/${id}`);
    };
    const customers = _.orderBy(props.group.customers, ['value'], ['desc']);

    return (
        <Grid item xs={12}>
            <Accordion expanded={toggle}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} onClick={() => setToggle(!toggle)}>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <h4>{props.group.title}</h4>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <em>{props.group.customers.length} kpl</em>
                        </Grid>
                    </Grid>
                </AccordionSummary>

                <AccordionDetails>
                    <Grid container>
                        {customers.map((customer) => (
                            <Grid item xs={12} key={customer.id}>
                                <div className="location-item" onClick={() => onClickItem(customer.id)}>
                                    <span>{customer.name}</span>
                                    {props.showLeadStageBadge && customer.leadStage != null && (
                                        <Chip
                                            label={t(getLeadStageTranslationKey(customer.leadStage))}
                                            size="small"
                                            variant="outlined"
                                            sx={{ ml: 1 }}
                                        />
                                    )}
                                    <span style={{ float: 'right' }}>
                                        {formatCurrency(customer.value, 2, currency)}
                                    </span>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
}
